const readEnv = (key: string, fallback?: string) => {
  const value = process.env[key];
  if (value !== undefined && value !== '') {
    return value;
  }
  return fallback;
};

export const API_BASE_URL = readEnv('REACT_APP_API_BASE_URL', 'https://api.preprod.cerberus.idgateway.net')!;
export const API_TOKEN = readEnv('REACT_APP_API_TOKEN');
export const AWS_REGION = readEnv('REACT_APP_REGION') || '';
export const IDENTITY_POOL_ID = readEnv('REACT_APP_IDENTITY_POOL_ID') || '';
